/** React */
import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import moment from "moment";

/** MUI icons */
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import CheckIcon from "@mui/icons-material/Check";
// import CloseIcon from "@mui/icons-material/Close";
// import HelpIcon from "@mui/icons-material/Help";
// import ReportProblemIcon from "@mui/icons-material/ReportProblemRounded";
// import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import Rotate90DegreesCcwIcon from "@mui/icons-material/Rotate90DegreesCcw";
import SaveIcon from "@mui/icons-material/Save";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

/** MUI */
import { Box, Container, FormGroup, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";

/** Components */
// import BaseSelect from "../../ui/BaseSelect";
import { fetchFileFromS3, getFileExtension, zeroPad } from "../../../utils/utils";
import { useGlobalContext } from "../../../context/GlobalContext";
import AccordionTotals from "./AccordionTotals";
import BaseActionsPreviewFile from "../BaseActionsPreviewFile";
import BaseButton from "../../ui/BaseButton";
import BaseSnackbar from "../../ui/BaseSnackbar";
import BaseSwitch from "../../ui/BaseSwitch";
import classes from "../MainConverter.module.css";
import conversionService from "../../../services/conversion";
import CustomDatePicker from "../../ui/CustomDatePicker";
import DetailsTable from "./DetailsTable";
import LightTooltip from "../../ui/LightTooltip";

// This line is important for the correct functioning of the library
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

/** Global functions */
const compareArrays = (arr1, arr2) => {
    // Verifica si alguno de los arreglos es null, undefined o de distinta longitud
    if (!arr1 || !arr2 || arr1.length !== arr2.length) return true; // Consideramos diferentes si alguno es nulo, indefinido o si tienen distinta longitud

    // Función para verificar si los objetos son diferentes
    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return true; // Son diferentes si tienen diferente cantidad de claves

        return keys1.some((key) => {
            if (!obj2.hasOwnProperty(key)) return true;

            let val1 = obj1[key];
            let val2 = obj2[key];

            // Comparar objetos anidados
            if (typeof val1 === "object" && val1 !== null && typeof val2 === "object" && val2 !== null) {
                return compareObjects(val1, val2);
            }

            const bothNumbers = !isNaN(Number(val1)) && !isNaN(Number(val2));
            if (bothNumbers) {
                val1 = Number(val1);
                val2 = Number(val2);
            }

            const bothDates = (isMomentDate(val1) || isStringDate(val1)) && (isMomentDate(val2) || isStringDate(val2));
            if (bothDates) {
                val1 = new Date(val1).getTime();
                val2 = new Date(val2).getTime();
            }

            // console.log(`Comparando clave "${key}":`, { [key]: val1 }, { [key]: val2 });
            return val1 !== val2;
        });
    };

    // Comparar en posición correspondiente
    return !arr1.every((obj1, index) => !compareObjects(obj1, arr2[index]));
};

// Helpers para verificar tipos de fecha
const isMomentDate = (val) => val && typeof val.isValid === "function" && val.isValid();
const isStringDate = (val) => val && !isNaN(new Date(val).getTime());

const ConversionPreview = (props) => {
    const {
        handleClickDownload,
        removeBanner,
        account,
        accounts,
        correlative,
        handleClickHelp,
        fileData,
        __html,
        conversionData,
        fileNameFull,
        isHistory,
        groupedData,
        setIsLoading,
        // setOpenModalGrouped,
        setRowsModal,
        // setOpenModalGroupedHist,
        // setModalType,
        setRows,
        setBasePreviewData,
        basePreviewData,
        internal,
        initData,
        setShowPrev,
        checkedInvSigngs,
        setCheckedInvSigngs,
        checkedInvDay,
        setCheckedInvDay,
        checkedDesRef,
        setCheckedDesRef,
        setDateFormat,
        dateFormat,
        reloadCases,
        handleGetConversions,
    } = props;

    /** Context */
    const { t, todos, theme } = useGlobalContext();

    /** Component states */
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [rowsDet, setRowsDet] = useState([]);
    const [rowsDetOG, setRowsDetOG] = useState([]);
    const [conversionDataNew, setConversionDataNew] = useState(
        groupedData ? groupedData.conversions[0] : conversionData
    );
    const [conversionDataGrp, setConversionDataGrp] = useState(groupedData ?? null);
    const [conversionFile, setConversionFile] = useState(fileData);
    const [conversionFileName, setConversionFileName] = useState(fileNameFull);
    const [actualDocIndex, setActualDocIndex] = useState(0);
    const [amountExt, setAmountExt] = useState([]);
    const [filters, setFilters] = useState({
        filtersArray: [
            {
                type: "",
                value: "",
                since: "",
                until: "",
            },
        ],
    });
    const [show, setShow] = useState(false);
    const [texto, setTexto] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [scale, setScale] = useState(1.0);
    const [rotate, setRotate] = useState(0);
    const [convChanges, setConvChanges] = useState(false);
    const [showDateEdit, setShowDateEdit] = useState(false);
    const [initDate, setInitDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [ogCheck, setOgCheck] = useState(conversionDataNew.switch_day_month ?? false);

    /** Component references */
    const previousRowsRef = useRef(null);
    const previousConvInfoRef = useRef(null);
    const tableRef = useRef(null);

    /** Component functions */
    useEffect(() => {
        // Compara si rows o convInfo han cambiado respecto a los valores anteriores
        const rowsChanged = compareArrays(previousRowsRef.current, rowsDetOG);
        const convInfoChanged = compareArrays(previousConvInfoRef.current, amountExt);

        // Solo actualizar si hay cambios en rows o convInfo
        if (rowsChanged || convInfoChanged || ogCheck !== checkedInvDay) {
            setConvChanges(true);
        } else {
            setConvChanges(false);
        }
    }, [rowsDetOG, amountExt, ogCheck, checkedInvDay]);

    const handleChangeInitDate = (event) => {
        setInitDate(event);
    };

    const handleChangeEndDate = (event) => {
        setEndDate(event);
    };

    const handleChangeSwitchInv = (event) => {
        setCheckedInvSigngs(event.target.checked);

        const newRows = rowsDetOG.map((item) => ({
            ...item,
            amount: item.amount * -1,
        }));

        const newExpense = amountExt[3].value;
        const newIncome = amountExt[2].value;

        const newArr = amountExt.map((item) => {
            if (item.type === "income") {
                item.value = newExpense * -1;
            }
            if (item.type === "expenses") {
                item.value = newIncome * -1;
            }
            return item;
        });
        setAmountExt(newArr);

        setRowsDet(newRows);
        setRowsDetOG(newRows);
    };

    const handleChangeSwitchInvDay = (event) => {
        setCheckedInvDay(event.target.checked);

        let newFormat = todos.dateFormat;
        if (event.target.checked) {
            newFormat = todos.dateFormat === "MM/DD/YYYY" ? "DD/MM/YYYY" : "MM/DD/YYYY";
        }

        setDateFormat(newFormat);
    };

    const handleChangeSwitchDesRef = (event) => {
        setCheckedDesRef(event.target.checked);

        const newRows = rowsDetOG.map((item) => ({
            ...item,
            description: item.reference,
            reference: item.description,
        }));

        setRowsDet(newRows);
        setRowsDetOG(newRows);
    };

    const saveChanges = async (isInternal) => {
        setIsLoading(true);

        const conversionDataUpd = {
            ...conversionDataNew,
            total_transactions: isNaN(parseFloat(amountExt[0].value)) ? 0 : parseFloat(amountExt[0].value),
            initial_balance: isNaN(parseFloat(amountExt[1].value)) ? 0 : parseFloat(amountExt[1].value),
            total_credits: isNaN(parseFloat(amountExt[2].value)) ? 0 : parseFloat(amountExt[2].value),
            total_debits: isNaN(parseFloat(amountExt[3].value)) ? 0 : parseFloat(amountExt[3].value),
            balance: isNaN(parseFloat(amountExt[4].value)) ? 0 : parseFloat(amountExt[4].value),
            switch_day_month: checkedInvDay,
            switch_signs: checkedInvSigngs,
            switch_reverse: checkedDesRef,
            transactions: rowsDetOG,
        };

        const newTrans = rowsDetOG.map((item) => ({
            _id: item.new ? null : item._id,
            date: item.date ? item.date.format("YYYY-MM-DD") : null,
            amount: item.amount ?? 0,
            reference: item.reference,
            description: item.description,
        }));

        const params = {
            conversion_id: conversionDataNew._id,
            conversion_total_transactions: isNaN(parseFloat(amountExt[0].value)) ? 0 : parseFloat(amountExt[0].value),
            conversion_total_debits: isNaN(parseFloat(amountExt[3].value)) ? 0 : parseFloat(amountExt[3].value),
            conversion_total_credits: isNaN(parseFloat(amountExt[2].value)) ? 0 : parseFloat(amountExt[2].value),
            conversion_initial_balance: isNaN(parseFloat(amountExt[1].value)) ? 0 : parseFloat(amountExt[1].value),
            conversion_balance: isNaN(parseFloat(amountExt[4].value)) ? 0 : parseFloat(amountExt[4].value),
            signs: checkedInvSigngs,
            date: checkedInvDay,
            reverse: checkedDesRef,
            transactions: newTrans,
        };

        if (isInternal) {
            params.support = true;
        }

        await conversionService
            .updateConversion(params)
            .then(() => {
                if (isInternal) {
                    setTexto(t("inbox.publishSucc"));
                } else {
                    setTexto(t("converter.changeSaved"));
                }
                setAlertType("success");
                setShow(true);

                previousConvInfoRef.current = JSON.parse(JSON.stringify(amountExt));
                previousRowsRef.current = JSON.parse(JSON.stringify(rowsDetOG));
                setOgCheck(checkedInvDay);
                setConvChanges(false);

                if (conversionDataGrp) {
                    setConversionDataGrp({
                        ...conversionDataGrp,
                        conversions: conversionDataGrp.conversions.map((item) =>
                            item._id === conversionDataUpd._id ? conversionDataUpd : item
                        ),
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });

        setIsLoading(false);
    };

    const handleCloseSnackBar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setShow(false);
    };

    const handleGoBack = () => {
        if (internal) {
            setShowPrev(false);
            reloadCases();
        } else {
            removeBanner();
            setRows([]);
            setRowsModal([]);
            setFilters({});
            handleGetConversions(null, false);
        }
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const nextPage = () => {
        setPageNumber((prevNum) => prevNum + 1);
    };

    const lastPage = () => {
        setPageNumber(numPages);
    };

    const prevPage = () => {
        setPageNumber((prevNum) => prevNum - 1);
    };

    const firstPage = () => {
        setPageNumber(1);
    };

    const getFile = async (file_name) => {
        const data = await fetchFileFromS3(file_name);
        if (data) {
            setConversionFile(data);
        }
    };

    // const handleChange = async (event) => {
    //     setIsLoading(true);
    //     let newData = {};
    //     let finalIndex;

    //     if (event.target.value !== 0) {
    //         finalIndex = groupedData.conversions.findIndex((item) => item._id === event.target.value);
    //         newData = groupedData.conversions.find((item) => item._id === event.target.value);
    //     } else {
    //         finalIndex = -1;
    //         newData = groupedData.conversions[0];
    //     }

    //     setActualDocIndex(finalIndex);

    //     setConversionFileName(newData.uploaded_file);
    //     setPageNumber(1);

    //     await getFile(newData.uploaded_file_s3);

    //     setBasePreviewData({
    //         id: newData._id,
    //         type: "bankStatement",
    //     });

    //     if (event.target.value !== 0) {
    //         setConversionDataNew(newData);
    //     } else {
    //         setConversionDataNew(groupedData);
    //     }
    //     setAccountPrev(event.target.value);
    //     setIsLoading(false);
    // };

    // const accountsPrev = groupedData
    //     ? [{ id: 0, name: t("converter.groupedConv") }].concat(
    //           groupedData.conversions.map((item) => ({ id: item._id, name: item.uploaded_file }))
    //       )
    //     : [];

    // const showConversions = () => {
    //     setModalType("bankStatement");
    //     setOpenModalGrouped(true);
    //     setOpenModalGroupedHist(true);
    //     const newRows = groupedData.conversions.map((item) => ({
    //         id: item._id,
    //         number: item.correlative,
    //         file_name: item.uploaded_file,
    //         file_name_s3: item.uploaded_file_s3,
    //         period:
    //             item.id_status !== 2 && item.id_status !== 3
    //                 ? "-"
    //                 : `${moment.utc(item.initial_date).format(todos.dateFormat)} - ${moment
    //                       .utc(item.end_date)
    //                       .format(todos.dateFormat)}`,
    //         status: item.id_status,
    //     }));
    //     setRowsModal(newRows);
    // };

    // const success = groupedData?.conversions.filter((item) => item.id_status === 2 || item.id_status === 3).length;

    // const revision = groupedData?.conversions.filter((item) => item.id_status === 4).length;

    // const errConv = groupedData?.conversions.filter((item) => item.id_status === 5).length;

    const totalRevenue = parseFloat(
        rowsDetOG
            .reduce((accumulator, currentValue) => {
                return currentValue.amount > 0 ? accumulator + currentValue.amount : accumulator;
            }, 0)
            .toFixed(2)
    );

    const totalEgress = parseFloat(
        rowsDetOG
            .reduce((accumulator, currentValue) => {
                return currentValue.amount < 0 ? accumulator + currentValue.amount : accumulator;
            }, 0)
            .toFixed(2)
    );

    // Function to check for duplicate entries
    function hasDuplicateEntries(data) {
        const map = new Map();

        for (const item of data) {
            const key = `${item.amount}-${item.date}-${item.description}`;

            if (map.has(key)) {
                return true; // Duplicate found
            } else {
                map.set(key, true);
            }
        }

        return false;
    }

    const handleNextDoc = async (direction) => {
        setIsLoading(true);

        const newData = conversionDataGrp.conversions[actualDocIndex + direction];

        setActualDocIndex(actualDocIndex + direction);
        setConversionFileName(newData.uploaded_file);
        setOgCheck(newData.switch_day_month ?? false);
        setPageNumber(1);

        await getFile(newData.uploaded_file_s3);

        setBasePreviewData({
            id: newData._id,
            type: "bankStatement",
        });

        setConversionDataNew(newData);
        setIsLoading(false);
    };

    useEffect(() => {
        const newAmountExt = [
            {
                type: "trans",
                value: conversionDataNew.total_transactions ?? 0,
            },
            {
                type: "initAmount",
                value: conversionDataNew.initial_balance ?? 0,
            },
            {
                type: "income",
                value: conversionDataNew.total_credits ?? conversionDataNew.credits_total?.toFixed(2),
            },
            {
                type: "expenses",
                value: conversionDataNew.total_debits ?? conversionDataNew.debits_total?.toFixed(2),
            },
            {
                type: "finalBalance",
                value: conversionDataNew.balance ?? 0,
            },
        ];
        setAmountExt(newAmountExt);

        const newRows = conversionDataNew.transactions
            .filter((item) => !item.deleted)
            .map((item) => ({
                ...item,
                date: item.date ? moment.utc(item.date) : null,
            }));

        setRowsDet(newRows);
        setRowsDetOG(newRows);
        setInitDate(conversionDataNew.initial_date ? moment.utc(conversionDataNew.initial_date) : null);
        setEndDate(conversionDataNew.end_date ? moment.utc(conversionDataNew.end_date) : null);

        previousConvInfoRef.current = JSON.parse(JSON.stringify(newAmountExt));
        previousRowsRef.current = JSON.parse(JSON.stringify(newRows));
    }, [conversionDataNew]);

    useEffect(() => {
        if (!internal) {
            setCheckedInvSigngs(conversionDataNew.switch_signs ?? false);
            setCheckedInvDay(conversionDataNew.switch_day_month ?? false);
            setCheckedDesRef(conversionDataNew.switch_reverse ?? false);
        }
    }, [conversionDataNew, setCheckedInvDay, setCheckedInvSigngs, setCheckedDesRef, internal]);

    const filterByStatus = (value, arr) => {
        let newRows = [];

        switch (value) {
            //Info faltante
            case 1:
                newRows = arr.filter((item) => !item.date || !item.description || !item.amount);
                break;
            //Fechas invalidas
            case 2:
                newRows = arr.filter(
                    (item) =>
                        !item.date ||
                        !moment(item.date).isValid() ||
                        moment(item.date).isBefore(initDate.subtract(5, "days")) ||
                        moment(item.date).isAfter(endDate.add(5, "days"))
                );
                break;
            //Montos positivos
            case 3:
                newRows = arr.filter((item) => item.amount > 0);
                break;
            //Montos negativos
            case 4:
                newRows = arr.filter((item) => item.amount < 0);
                break;
            //Duplicados
            default:
                const countMap = new Map();
                const repeatedObjects = [];

                arr.forEach((obj) => {
                    const key = `${obj.amount}-${obj.date}-${obj.description}`;
                    if (countMap.has(key)) {
                        countMap.set(key, countMap.get(key) + 1);
                    } else {
                        countMap.set(key, 1);
                    }
                });

                arr.forEach((obj) => {
                    const key = `${obj.amount}-${obj.date}-${obj.description}`;
                    if (countMap.get(key) > 1) {
                        repeatedObjects.push(obj);
                    }
                });
                newRows = repeatedObjects;
                break;
        }

        return newRows;
    };

    const goToTable = (type) => {
        tableRef.current.scrollIntoView({ behavior: "smooth" });

        if (type) {
            const aux = [...filters.filtersArray];
            aux[0].since = "";
            aux[0].until = "";
            aux[0].type = 1;

            switch (type) {
                case "date":
                    aux[0].value = 2;
                    break;
                case "duplicated":
                    aux[0].value = 5;
                    break;
                case "revenue":
                    aux[0].value = 3;
                    break;
                default:
                    aux[0].value = 4;
                    break;
            }

            const newRows = filterByStatus(aux[0].value, rowsDetOG);

            setRowsDet(newRows);

            setFilters({
                ...filters,
                filtersArray: aux,
            });
        }
    };

    const zoomIn = () => {
        setScale((prevScale) => prevScale + 0.2);
    };

    const zoomOut = () => {
        setScale((prevScale) => Math.max(prevScale - 0.2, 0.2));
    };

    const rotateLeft = () => {
        setRotate((prevRotate) => (prevRotate + 270) % 360);
    };

    const handleEditPeriods = () => {
        setShowDateEdit(true);
    };

    const handleSavePeriods = async () => {
        setShowDateEdit(false);

        setIsLoading(true);

        const params = {
            conversion_id: conversionDataNew._id,
            conversion_initial_date: initDate.format("YYYY-MM-DD"),
            conversion_end_date: endDate.format("YYYY-MM-DD"),
        };

        await conversionService
            .updateConversionPeriod(params)
            .then(() => {
                setTexto(t("converter.changeSaved"));
                setAlertType("success");
                setShow(true);
            })
            .catch((err) => {
                console.log(err);
            });

        setIsLoading(false);
    };

    return (
        <Container maxWidth="xl">
            <Typography variant="h2" color="secondary" pt={5} gutterBottom ml={0.5}>
                {internal ? (
                    <>
                        {initData.company}
                        <Typography variant="h2" component="span" color="primary">
                            {` > ${initData.bank_name} > ${initData.global_case}`}
                        </Typography>
                    </>
                ) : (
                    <>
                        {accounts.find((item) => item.id === account)?.name}
                        <Typography variant="h2" component="span" color="primary">
                            {conversionDataGrp
                                ? " > GROUP-" + zeroPad(conversionDataGrp.correlative ?? 0, 5)
                                : ` > ${t("subscription.conversion")} #${zeroPad(correlative, 5)}`}
                        </Typography>
                    </>
                )}
            </Typography>
            <Stack direction="row" justifyContent="space-between" py={2}>
                <BaseButton variantType="primaryOutlined" onClick={handleGoBack} sizebutton="m">
                    {isHistory ? t("inbox.goBackList") : t("register.back")}
                </BaseButton>
                {!internal && (
                    <Typography gutterBottom>
                        <BaseButton
                            variantType="errorText"
                            onClick={() => handleClickHelp("conversion", "bankStatement", conversionDataNew._id)}
                        >
                            {t("accounts.needHelp")}
                        </BaseButton>
                    </Typography>
                )}
            </Stack>
            {/* {groupedData && (
                <Grid container spacing={3} mt={0.2}>
                    <Grid item xs={12} md={5}>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box className={classes.backWhiteDet}>
                            <Stack direction="row" spacing={2} justifyContent="space-between">
                                <Box>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography variant="h3">{t("converter.conversionStatus")}</Typography>
                                        <LightTooltip title={t("miscellaneous.toolHelpConvDet")}>
                                            <HelpIcon fontSize="small" color="primary" />
                                        </LightTooltip>
                                    </Stack>
                                    <Grid container spacing={2} sx={{ pl: 2 }}>
                                        {success > 0 && (
                                            <Grid item>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Typography>{success}</Typography>
                                                    <CheckIcon fontSize="small" color="success" />
                                                </Stack>
                                            </Grid>
                                        )}
                                        {revision > 0 && (
                                            <Grid item>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Typography>{revision}</Typography>
                                                    <AccessTimeIcon fontSize="small" color="warning" />
                                                </Stack>
                                            </Grid>
                                        )}
                                        {errConv > 0 && (
                                            <Grid item>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Typography>{errConv}</Typography>
                                                    <CloseIcon fontSize="small" color="error" />
                                                </Stack>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                                <BaseButton
                                    endIcon={<SearchIcon style={{ width: "27px", height: "27px" }} />}
                                    onClick={showConversions}
                                    variantType="convertOutlinedButton"
                                >
                                    {t("converter.seeDetails")}
                                </BaseButton>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            )} */}
            <Grid container spacing={3} pb={3}>
                <Grid item xs={12} md={4.5}>
                    <Box sx={{ bgcolor: "#FFF", px: "38px", py: "10px", borderBottom: "1px solid #ccc" }}>
                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                            <Typography>{t("dashboard.accState")}</Typography>
                            {/* <Box sx={{ width: 250 }}>
                                    <BaseSelect
                                        value={accountPrev}
                                        values={accountsPrev}
                                        onChange={handleChange}
                                        label={t("dashboard.accState")}
                                    ></BaseSelect>
                                </Box> */}
                            {conversionDataGrp && (
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography fontSize={16}>{t("converter.importedDocs")}</Typography>
                                    <IconButton
                                        sx={{
                                            color:
                                                actualDocIndex === 0
                                                    ? "rgba(0, 0, 0, 0.26)"
                                                    : theme.palette.primary.main,
                                        }}
                                        disabled={actualDocIndex === 0}
                                        onClick={() => handleNextDoc(-1)}
                                    >
                                        <KeyboardArrowLeftIcon />
                                    </IconButton>
                                    <Typography variant="h3" gutterBottom>
                                        {`${actualDocIndex + 1} / ${conversionDataGrp.conversions.length}`}
                                    </Typography>
                                    <IconButton
                                        sx={{
                                            color:
                                                actualDocIndex === conversionDataGrp.conversions.length - 1
                                                    ? "rgba(0, 0, 0, 0.26)"
                                                    : theme.palette.primary.main,
                                        }}
                                        disabled={actualDocIndex === conversionDataGrp.conversions.length - 1}
                                        onClick={() => handleNextDoc(1)}
                                    >
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </Stack>
                            )}
                        </Stack>
                    </Box>
                    {(conversionFile || conversionDataGrp) && (
                        <Box
                            sx={{
                                height: 650,
                                overflow: "auto",
                            }}
                        >
                            {getFileExtension(
                                conversionFileName
                                    ? conversionFileName?.toLowerCase()
                                    : conversionFile.path?.toLowerCase()
                            ) === "pdf" ? (
                                <Document file={conversionFile} onLoadSuccess={onDocumentLoadSuccess}>
                                    <Page pageNumber={pageNumber} scale={scale} rotate={rotate} />
                                </Document>
                            ) : getFileExtension(conversionFileName ? conversionFileName : conversionFile.path) ===
                                  "xls" ||
                              getFileExtension(conversionFileName ? conversionFileName : conversionFile.path) ===
                                  "xlsx" ? (
                                __html ? (
                                    <Box className={classes.workbookContainer} dangerouslySetInnerHTML={{ __html }} />
                                ) : (
                                    <Box
                                        className={classes.workbookContainer}
                                        sx={{ bgcolor: "#CCC", maxHeight: 1000 }}
                                        justifyContent="center"
                                        display="flex"
                                        alignItems="center"
                                    >
                                        {t("converter.cannotPrev")}
                                    </Box>
                                )
                            ) : (
                                <Box
                                    className={classes.workbookContainer}
                                    sx={{ bgcolor: "#CCC", maxHeight: 1000 }}
                                    justifyContent="center"
                                    display="flex"
                                    alignItems="center"
                                >
                                    {t("converter.cannotPrev")}
                                </Box>
                            )}
                        </Box>
                    )}
                    <Stack
                        sx={{
                            bgcolor: "#FFF",
                            px: "38px",
                            py: "10px",
                            borderTop: "1px solid #ccc",
                        }}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Box>
                            <LightTooltip title={t("converter.reduce")}>
                                <IconButton onClick={zoomOut} color="primary">
                                    <ZoomOutIcon />
                                </IconButton>
                            </LightTooltip>
                            <LightTooltip title={t("converter.zoom")}>
                                <IconButton onClick={zoomIn} color="primary">
                                    <ZoomInIcon />
                                </IconButton>
                            </LightTooltip>
                            <LightTooltip title={t("converter.rotateLeft")}>
                                <IconButton onClick={rotateLeft} color="primary">
                                    <Rotate90DegreesCcwIcon />
                                </IconButton>
                            </LightTooltip>
                        </Box>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            <IconButton disabled={pageNumber === 1} onClick={firstPage} color="primary">
                                <FirstPageIcon />
                            </IconButton>
                            <IconButton disabled={pageNumber === 1} onClick={prevPage} color="primary">
                                <KeyboardArrowLeftIcon />
                            </IconButton>
                            <Typography>
                                {pageNumber} - {numPages}
                            </Typography>
                            <IconButton disabled={pageNumber === numPages} onClick={nextPage} color="primary">
                                <KeyboardArrowRightIcon />
                            </IconButton>
                            <IconButton disabled={pageNumber === numPages} onClick={lastPage} color="primary">
                                <LastPageIcon />
                            </IconButton>
                        </Stack>
                        <BaseActionsPreviewFile basePreviewData={basePreviewData} />
                    </Stack>
                </Grid>
                <Grid item xs={12} md={7.5}>
                    <Paper elevation={0} square className={classes.mainCard}>
                        <Grid container sx={{ marginBottom: 3 }}>
                            <Grid item xs={12} md={7}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography variant="h2" color="primary" pb={2}>
                                            {t("invoicing.resume")}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3} pb={1.5}>
                                        <Typography fontWeight={600}>{t("converter.bankStatement")}:</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Typography>{conversionDataNew.uploaded_file}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3} pb={1.5}>
                                        <Typography fontWeight={600}>{t("dashboard.bank")}:</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Typography>{conversionDataNew.bank_name ?? "-"}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3} pb={1.5}>
                                        <Typography fontWeight={600}>{t("converter.AccNum")}:</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Typography>{conversionDataNew.account_number ?? "-"}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "center" }}>
                                        <Typography fontWeight={600}>{t("payment.period")}:</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            {!showDateEdit ? (
                                                <Typography>
                                                    {!initDate && !endDate
                                                        ? "N/A"
                                                        : `${initDate?.format(
                                                              dateFormat ?? todos.dateFormat
                                                          )} - ${endDate?.format(dateFormat ?? todos.dateFormat)}`}
                                                </Typography>
                                            ) : (
                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    alignItems="center"
                                                    sx={{ width: "70%" }}
                                                >
                                                    <CustomDatePicker
                                                        format={dateFormat}
                                                        label={t("filters.since")}
                                                        onChange={handleChangeInitDate}
                                                        value={initDate}
                                                    />
                                                    <CustomDatePicker
                                                        format={dateFormat}
                                                        label={t("filters.until")}
                                                        onChange={handleChangeEndDate}
                                                        value={endDate}
                                                    />
                                                </Stack>
                                            )}
                                            {!showDateEdit && (
                                                <LightTooltip title={t("converter.edit")}>
                                                    <IconButton
                                                        onClick={handleEditPeriods}
                                                        color="primary"
                                                        size="small"
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </LightTooltip>
                                            )}
                                            {showDateEdit && (
                                                <LightTooltip title={t("team.save")}>
                                                    <IconButton
                                                        onClick={handleSavePeriods}
                                                        color="primary"
                                                        size="small"
                                                    >
                                                        <SaveIcon fontSize="small" />
                                                    </IconButton>
                                                </LightTooltip>
                                            )}
                                            {/* {groupedData?.missing_period && (
                                                <LightTooltip title={t("converter.toolPeriods")}>
                                                    <ReportProblemIcon color="error" fontSize="small" />
                                                </LightTooltip>
                                            )} */}
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {!internal && (
                                <Grid item xs={12} md={5}>
                                    <Typography variant="h2" color="primary" gutterBottom>
                                        {t("converter.transform")}
                                    </Typography>
                                    <FormGroup>
                                        <BaseSwitch
                                            checked={checkedInvSigngs}
                                            label={t("converter.invertSings")}
                                            labelPlacement="end"
                                            labelVariant="body1"
                                            onChange={handleChangeSwitchInv}
                                        />
                                        <BaseSwitch
                                            checked={checkedInvDay}
                                            label={t("converter.invertDayMonth")}
                                            labelPlacement="end"
                                            labelVariant="body1"
                                            onChange={handleChangeSwitchInvDay}
                                        />
                                        <BaseSwitch
                                            checked={checkedDesRef}
                                            label={t("converter.descrAndReference")}
                                            labelPlacement="end"
                                            labelVariant="body1"
                                            onChange={handleChangeSwitchDesRef}
                                        />
                                    </FormGroup>
                                </Grid>
                            )}
                        </Grid>
                        <AccordionTotals
                            amountExt={amountExt}
                            setAmountExt={setAmountExt}
                            rowsDet={rowsDetOG}
                            conversionData={conversionDataNew}
                            goToTable={goToTable}
                            totalRevenue={totalRevenue}
                            totalEgress={totalEgress}
                            hasDuplicateEntries={hasDuplicateEntries}
                            checkedInvSigngs={checkedInvSigngs}
                        />
                    </Paper>
                    <DetailsTable
                        handleClickDownload={handleClickDownload}
                        saveChanges={saveChanges}
                        internal={internal}
                        rowsDet={rowsDet}
                        setRowsDet={setRowsDet}
                        rowsDetOG={rowsDetOG}
                        setRowsDetOG={setRowsDetOG}
                        filters={filters}
                        setFilters={setFilters}
                        tableRef={tableRef}
                        filterByStatus={filterByStatus}
                        conversionData={conversionDataNew}
                        amountExt={amountExt}
                        totalRevenue={totalRevenue}
                        totalEgress={totalEgress}
                        hasDuplicateEntries={hasDuplicateEntries}
                        convChanges={convChanges}
                        dateFormat={dateFormat}
                    />
                </Grid>
            </Grid>
            <BaseSnackbar type={alertType} show={show} message={texto} onClose={handleCloseSnackBar} />
        </Container>
    );
};

export default ConversionPreview;
